var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imprint"},[_c('router-link',{staticClass:"imprint__close",attrs:{"to":"/"}},[_vm._v("X")]),_vm._v(" "),_c('div',{staticClass:"imprint__text",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e54f406","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imprint.vue
// module id = null
// module chunks = 